import { render } from "./NotifsOverlay.vue?vue&type=template&id=ca7adb80"
import script from "./NotifsOverlay.vue?vue&type=script&lang=js"
export * from "./NotifsOverlay.vue?vue&type=script&lang=js"

import "./NotifsOverlay.vue?vue&type=style&index=0&id=ca7adb80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__